<template>   
  <div class="suspend-side">
    <div class="suspend-side-item" @mouseover="mouseOver(1)" @mouseout="mouseOut()">
      <i class="suspend-side-img icon-chat"></i>
      <div class="suspend-side-text">
        <span>关注</span>
        <span>公众号</span>
      </div>
    </div>
    <div class="suspend-qr-body" v-show="sideDirector == 1">
      <span class="suspend-chat-span">扫码免费领取礼包</span>
      <div class="suspend-chat-box">
        <img class="suspend-chat-img" :src="webSite.wechat_public">
        <div class="suspend-chat-scan"></div>
      </div>
    </div>
    <div class="suspend-side-item" @mouseover="mouseOver(2)" @mouseout="mouseOut()" @click="enterApk">
      <i class="suspend-side-img icon-app"></i>
      <div class="suspend-side-text">
        <span>APP</span>
        <span>下载</span>
      </div>
    </div>
    <div class="suspend-qr-body" v-show="sideDirector == 2">
      <span class="suspend-qr-span">扫码下载至手机</span>
      <span class="suspend-qr-span">点击下载到电脑</span>
      <div class="suspend-apk-box">
        <img class="suspend-apk-img" :src="baseQrAddress+'type=qr_apk&game_tag=apk'">
        <div class="suspend-apk-scan"></div>
      </div>
    </div>
    <div class="suspend-side-item" @click="enterName">
      <i class="suspend-side-img icon-name"></i>
      <div class="suspend-side-text">
        <span>游戏</span>
        <span>冠名</span>
      </div>
    </div>
    <div class="suspend-side-item" @click="enterCustomer">
      <i class="suspend-side-img icon-customer"></i>
      <span class="suspend-side-text">
        <span>在线</span>
        <span>客服</span>
      </span>
    </div>
    <div class="suspend-side-item" @click="goBack">
      <i class="suspend-side-img icon-top"></i>
      <span class="suspend-side-text">
        <span>返回</span>
        <span>顶部</span>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
      name:'SuspendSide',
      computed:{
        baseImageAddress(){
          return this.$store.state.constant.baseImageAddress;
        },
        baseQrAddress(){
          return this.$store.state.constant.baseQrAddress;
        },
        webSite(){
          return this.$store.state.home.webSite;
        },
      },
      methods:{
        goBack(){
          window.scrollTo(0,0);
        },
        enterName(){
          window.open(this.$router.resolve({name: "name"}).href,'_blank');
        },
        enterCustomer(){
          window.open(this.webSite.one_qq_url,"_blank");
        },
        enterApk(){
          this.$router.push({name:'apkDownload'});
        },
        mouseOver(value){
          this.sideDirector = value;
        },
        mouseOut(){
          this.sideDirector = 0;
        },
      },
      data(){
          return{
            sideDirector:0
          }
      },
      mounted(){
        
      }
  }
</script>
<style src="@/assets/css/suspend_side.css" scoped></style>
<style>
</style>